import { Component, OnInit, Input, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, FormControl } from '@angular/forms';
import { DialogCloseResult, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { DataStateChangeEvent, DetailExpandEvent, FilterService, GridComponent, GridDataResult, PageChangeEvent, RemoveEvent } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor, filterBy, State, process, FilterDescriptor } from '@progress/kendo-data-query';
import { FormCanDeactivate } from 'src/app/form-can-deactivate/form-can-deactivate.component';
import { Common } from 'src/app/common/common';
import { IDocument } from 'src/app/interface/IDocument';
import { CommonService } from 'src/app/service/common/common.service';
import { ClearEvent, FileRestrictions, SelectEvent } from '@progress/kendo-angular-upload';
import { INotes } from 'src/app/interface/IPriorApprovals';
import { IKeyPairValue } from 'src/app/interface/IKeyValuePair';
import { NotesService } from 'src/app/service/notes/notes.service';
import { NotificationService } from '@progress/kendo-angular-notification';
import * as $ from 'jquery';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

type AOA = any[][];

const flatten = filter => {
  const filters = (filter || {}).filters;
  if (filters) {
    return filters.reduce((acc, curr) => acc.concat(curr.filters ? flatten(curr) : [curr]), []);
  }
  return [];
};

const distinctTitle = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.title === x.title) === idx);

const distinctAgreementYear = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.agreementYear === x.agreementYear) === idx);

const distinctNotes = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.description === x.description) === idx);

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})

export class NotesComponent extends FormCanDeactivate implements OnInit, OnDestroy {
  @Input() agreementId: string;
  @Input() awardNumber: string;
  @Input() awardNickName: string;
  @Input() awardTitle: string;
  @Input() awardStatus: boolean;
  @Input() roles: string;

  @ViewChild('ngFormDirtyCheck') ngFormDirtyCheck: NgForm; // for dirty check
  @ViewChild('noteGrid') noteGrid: GridComponent;
  mimeMapping: Map<string, string> = new Map([['csv', 'text/csv'],
  ['jpg', 'image/jpeg'],
  ['jpeg', 'image/jpeg'],
  ['png', 'image/png'],
  ['pdf', 'application/pdf'],
  ['doc', 'application/msword'],
  ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  ['xls', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  ['ppt', 'application/vnd.ms-powerpoint'],
  ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  ['rtf', 'application/rtf'],
  ['csv', 'text/csv'],
  ['htm', 'text/html'],
  ['html', 'text/html'],
  ['zip', 'application/zip'],
  ['msg', 'application/vnd.ms-outlook']]);

  constructor(private dialogService: DialogService, private commonService: CommonService,
              private notificationService: NotificationService,
              private formBuilder?: FormBuilder, private notesService?: NotesService) {
              super();
            }

  public notesEntryForm: FormGroup;
  public notesList: INotes[] = [];
  public defaultGuid: string = '00000000-0000-0000-0000-000000000000';
  public inValidTitle: boolean = true;
  public isValidNoteSave: boolean = true;
  private editedRowIndex: number;
  public isSaveFlag: boolean = false;
  private counter: number = this.notesList.length;
  public deleteNoteIds: any[] = [];
  public agreementNoteId: string;
  public agreementYearList: any[] = [];
  public enableAgreementYear: boolean = false;
  public agreementYear: any = null;
  public agreementYears: any;
  // Document variables
  public dialogRef: DialogRef;
  public documentFormGroup: FormGroup;
  public uploadFileList: IDocument[] = [];
  public newUploadFileList: IDocument[] = [];
  public uploadFile: any = '';
  public documentUri: any;
  public fileName: string = '';
  public deleteDocuments: IDocument[] = [];
  public isDocumentTypeSelected: boolean = false;
  public isDocumentSelected: boolean = false;
  public isExistingDocumentName: boolean = false;
  public isValidForm: boolean = false;
  public selectedDataItem: any;
  public selectedRowIndex: number;
  public disabledUploadButton: boolean = false;
  public originalDocumentTypeList: IKeyPairValue[] = [];
  public documentTypeList: IKeyPairValue[] = [];
  public uploadRestrictions: FileRestrictions = {
    allowedExtensions: ['.jpg', '.jpeg', '.doc', '.docx', '.png', '.pdf', '.txt', '.xls', '.xlsx', '.msg', '.ppt', '.pptx', '.rtf', '.csv', '.zip', '.htm', '.html']
  };
  public disabledSelectFileButton: boolean = false;
  public moduleName = 'Notes';
  public validateFile: boolean = true;
  public isReadOnlyPage: boolean = false;
  public isEnableDocumentDialug: boolean = false;
  public isEditDocumentDialug: boolean = false;
  public fileExtension: any;
  public orgFileName: any;
  public SpDocumentName: any;
  // Pagination
  public notesListGrid: GridDataResult;
  public pageSize = 10;
  public skip = 0;
  public typedg: 'numeric' | 'input' = 'numeric';
  public buttonCount = 5;
  public info = true;
  public pageSizes = true;
  public previousNext = true;
  public text: string = '';
  public enteredSearchText: string = '';
  public reqstate: State = {
    skip: 0,
    take: 10
  };
  public filter?: CompositeFilterDescriptor;
  public filteredData: any = [];
  private intervaltime;
  public disableAddDocButton: boolean = false;
  // Column filter
  public categoryFilter: any[] = [];
  public titleValue: any[] = [];
  public agreementYearValue: any[] = [];
  public notesValue: any[] = [];
  // Preview
  public dialogPreviewRef: DialogRef;
  public data: any;
  public headData: any;
  public isEnableJPG: boolean = false;
  public isEnablemsg: boolean = false;
  public isEnableXLXS: boolean = false;
  public isEnableTXT: boolean = false;
  public isEnablePDF: boolean = false;
  public isEnableDOCX: boolean = false;
  public url: any;
  public documentURI: '';
  public enablePreviewDataItem: any;

  pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }

  dataStateChange(state: DataStateChangeEvent): void {
    this.reqstate = state;
    if (this.filteredData.length > 0) {
      this.notesListGrid = process(this.filteredData, this.reqstate);
    } else {
      this.notesListGrid = process(this.notesList, this.reqstate);
    }
  }

  filterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    const filterData = filterBy(this.notesList, filter);
    this.notesListGrid = process(filterData, this.reqstate);
  }

  ngOnInit(): void {
    this.initializeFormControls();
    this.getDocumentType();
    this.agreementYears = localStorage.getItem('awardAgreementYear');
    this.getAgreementYear();
    if (this.agreementId) {
      Common.loader('show');
      if (this.awardStatus === true) {
        this.isReadOnlyPage = true;
      } else {
        this.isReadOnlyPage = false;
      }
      if (this.roles === 'Observer') {
        this.disableAddDocButton = true;
      } else {
        this.disableAddDocButton = false;
      }
      this.getNotesInformation();
    }
    if (+environment.isAutoSaveEnableFlag === 1) {
      this.autoSave();
    }
  }

  // initialize Financial management form Controls
  initializeFormControls() {
    this.notesEntryForm = this.formBuilder.group({
      title: new FormControl(''),
      description: new FormControl(''),
      agreementYearValue: new FormControl('')
    });

    this.documentFormGroup = this.formBuilder.group({
      displayFileName: new FormControl(),
      documentType: new FormControl(),
      documentDescription: new FormControl(),
    });
  }

  // To get Document type
  getDocumentType() {
    this.commonService.getDocumentType().subscribe((response) => {
      this.originalDocumentTypeList = response;
      this.documentTypeList = this.originalDocumentTypeList.slice();
    });
  }

  // To get Notes Information
  public getNotesInformation() {
    this.notesService.getNotes(this.agreementId, this.agreementYear).subscribe((response) => {
      if (response.Notes && response.Notes.length > 0) {
        this.notesList = response.Notes;
        this.skip = 0;
        this.notesListGrid = {
          data: this.notesList.slice(this.skip, this.skip + this.pageSize),
          total: this.notesList.length
        };
        this.titleValue = distinctTitle(this.notesList.filter((x) => x.title !== ''));
        this.agreementYearValue = distinctAgreementYear(this.notesList.filter((x) => x.agreementYear !== null));
        this.notesValue = distinctNotes(this.notesList.filter((x) => x.description !== ''));
      } else {
        this.notesListGrid = null;
      }
      Common.loader('hide');
    });
  }

  // To set agreement year
  getAgreementYear() {
    this.agreementYearList = [];
    if (this.agreementYears > 0) {
      this.enableAgreementYear = true;
      for (let i = 1; i <= this.agreementYears; i++) {
        this.agreementYearList.push(i);
      }
    }
  }

  // agreement year Filter change
  agreementYearFilterChange(data: any) {
    this.notesList.forEach((item, idx) => {
      this.noteGrid.collapseRow(idx);
    });
    this.agreementYear = undefined;
    if (data) {
      this.agreementYear = data;
    } else {
      this.agreementYear = null;
    }
    this.getNotesInformation();
  }

  // To save deliverables
  saveNotes() {
    if (this.notesList.length > 0) {
      this.notesService.saveNotes(JSON.stringify(this.notesList)).subscribe((res: any) => {
        if (res) {
          this.getNotesInformation();
          this.getDocumentDetails(this.agreementNoteId);
        }
      });
    }
  }

  // To delete the Deliverables
  deleteNotes() {
    if (this.deleteNoteIds.length > 0) {
      this.notesService.deleteNotes(JSON.stringify(this.deleteNoteIds)).subscribe((resp: any) => {
        if (resp) {
          Common.loader('hide');
          this.routeAfterChange();
        }
      });
    }
  }

  // deliverable grid start
  public addHandler({ sender }, parentGrid) {
    this.agreementYear = '';
    this.notesList.forEach((item, idx) => {
      parentGrid.collapseRow(idx);
    });
    this.closeEditor(sender);
    this.initializeFormControls();
    sender.addRow(this.notesEntryForm);
  }

  public editHandler({ sender, rowIndex, dataItem }) {
    this.closeEditor(sender);
    this.notesEntryForm = this.formBuilder.group({
      title: dataItem.title,
      agreementYearValue: dataItem.agreementYear,
      description: dataItem.description,
    });
    this.editedRowIndex = rowIndex;
    sender.editRow(rowIndex, this.notesEntryForm);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew, dataItem }, agreementId: any, parentGrid) {
    this.filter = null;
    this.notesList.forEach((item, idx) => {
      parentGrid.collapseRow(idx);
    });
    this.isSaveFlag = this.validateNoteSave(formGroup);
    if (this.isSaveFlag) {
      const notesData: INotes = {};
      notesData.title = formGroup.controls.title.value;
      notesData.description = formGroup.controls.description.value;
      notesData.agreementYear = formGroup.controls.agreementYearValue.value ? formGroup.controls.agreementYearValue.value : null;
      if (isNew) {
        notesData.id = this.defaultGuid;
        notesData.agreementId = agreementId;
        notesData.rowId = this.counter++;
        this.notesList.push(notesData);
        this.notesListGrid = process(this.notesList, this.reqstate);
        this.saveNotes();
      } else {
        if (dataItem.id) {
          Object.assign(
            this.notesList.find(({ id }) => id === dataItem.id),
            notesData
          );
        } else {
          Object.assign(
            this.notesList.find(({ rowId }) => rowId === rowIndex),
            notesData
          );
        }
        this.notesListGrid = process(this.notesList, this.reqstate);
        this.saveNotes();
      }
      const element: HTMLElement = document.getElementById('submitBtn') as HTMLElement;
      element.click();
      this.notesEntryForm.reset();
      sender.closeRow(rowIndex);
    } else {
      this.mandatoryError();
    }
    this.show();
  }

  mandatoryError() {
    this.dialogRef = this.dialogService.open({
      title: 'Information',
      content: 'Please fill Title',
      actions: [
        { text: 'Ok', primary: true }
      ],
      width: 400,
    });
  }

  public show(): void {
    if (this.isSaveFlag) {
      this.notificationService.show({
        content: 'This has been saved.',
        position: { horizontal: 'center', vertical: 'bottom' },
        animation: { type: 'fade', duration: 500 },
        type: { style: 'success', icon: true },
        hideAfter: 1000,
      });
    }
  }

  public removeHandler({ dataItem }, parentGrid): void {
    this.dialogRef = this.dialogService.open({
      title: 'Please Confirm',
      content: 'Notes "' + dataItem.title + '" and all the associated document(s) will be deleted. Do you want to continue?',
      actions: [
        { text: 'Yes', primary: true },
        { text: 'No' }],
      width: 400,
    });
    this.dialogRef.result.subscribe((rs: any) => {
      if (rs.text && rs.text === 'Yes') {
        this.filter = null;
        if (dataItem.id) {
          this.notesList.forEach((item, idx) => {
            parentGrid.collapseRow(idx);
          });
          Common.loader('show');
          const getDocumentList: IDocument = {};
          getDocumentList.agreementId = null;
          getDocumentList.deliverableDetailId = null;
          getDocumentList.deliverableId = null;
          getDocumentList.agreementPriorApprovalId = null;
          getDocumentList.financialInformationId = null;
          getDocumentList.agreementNoteId = dataItem.id;
          getDocumentList.isAllDocument = false;
          this.commonService.getDocument(getDocumentList).subscribe((response) => {
            this.uploadFileList = response.Documents;
            if (this.uploadFileList.length > 0) {
              this.uploadFileList.forEach((ele: any) => {
                this.deleteDocuments.push(ele.id);
                this.commonService.deleteDocumnetFile(JSON.stringify(ele.documentURI)).subscribe((res: any) => {
                  if (res) {
                    this.commonService.deleteDocument(JSON.stringify(this.deleteDocuments)).subscribe((resp: any) => {
                      if (resp) {
                        const index = this.notesList.findIndex(({ id }) => id === dataItem.id);
                        this.deleteNoteIds.push(dataItem.id);
                        this.notesList.splice(index, 1);
                        this.notesListGrid = process(this.notesList, this.reqstate);
                        this.deleteNotes();
                      }
                    });
                  }
                });
              });
            } else {
              const index = this.notesList.findIndex(({ id }) => id === dataItem.id);
              this.deleteNoteIds.push(dataItem.id);
              this.notesList.splice(index, 1);
              this.notesListGrid = process(this.notesList, this.reqstate);
              this.deleteNotes();
            }
          });
        }
      }
    });
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
  }
  // deliverable grid start

  // after route change
  routeAfterChange() {
    const element: HTMLElement = document.getElementById('submitBtn') as HTMLElement;
    element.click();
    this.notificationService.show({
      content: 'Deleted Successfully.',
      position: { horizontal: 'center', vertical: 'bottom' },
      animation: { type: 'fade', duration: 500 },
      type: { style: 'success', icon: true },
      hideAfter: 1000,
    });
    this.agreementYear = '';
    this.ngOnInit();
  }

  // Validation for isEmpty
  isEmpty(paramValue: any): boolean {
    if (paramValue === null || paramValue === undefined || paramValue === '') {
      return true;
    } else {
      return false;
    }
  }

  public validateNoteSave(formGroup): boolean {
    this.inValidTitle = true;
    if (!(this.isEmpty(formGroup.controls.title.value))) {
      this.inValidTitle = false;
    }
    this.isValidNoteSave = this.inValidTitle === false ? true : false;
    return this.isValidNoteSave;
  }

  // grid column filter
  public categoryFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
    this.categoryFilter.splice(
      0, this.categoryFilter.length,
      ...flatten(filter).map(({ value }) => value)
    );
    return this.categoryFilter;
  }

  public titleValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'title',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public agreementYearValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'agreementYear',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public notesValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'description',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  // Document Grid codes
  detailExpanded(event: DetailExpandEvent) {
    const getDocumentList: IDocument = {};
    this.uploadFileList = [];
    if (event.dataItem) {
      Common.loader('show');
      this.agreementNoteId = event.dataItem.id;
      if (this.agreementNoteId) {
        getDocumentList.agreementId = null;
        getDocumentList.deliverableDetailId = null;
        getDocumentList.deliverableId = null;
        getDocumentList.agreementPriorApprovalId = null;
        getDocumentList.financialInformationId = null;
        getDocumentList.agreementNoteId = this.agreementNoteId;
        getDocumentList.isAllDocument = false;
        this.commonService.getDocument(getDocumentList).subscribe((response) => {
          if (response !== undefined && response.Documents.length > 0) {
            response.Documents.forEach(res => {
              this.notesList.forEach(ele => {
                if (ele.id === res.agreementNoteId) {
                  this.uploadFileList.push(res);
                  ele.uploadFileList = this.uploadFileList;
                }
              });
            });
          }
          Common.loader('hide');
        });
      } else {
        Common.loader('hide');
      }
    }

  }

  documentTypeChange(data: any) {
    if (data) {
      this.disabledSelectFileButton = true;
    }
  }

  // To get Document Information
  getDocumentDetails(agreementNoteId: string) {
    this.uploadFileList = [];
    const getDocumentList: IDocument = {};
    getDocumentList.agreementId = null;
    getDocumentList.deliverableDetailId = null;
    getDocumentList.deliverableId = null;
    getDocumentList.agreementPriorApprovalId = null;
    getDocumentList.financialInformationId = null;
    getDocumentList.agreementNoteId = agreementNoteId;
    getDocumentList.isAllDocument = false;
    this.commonService.getDocument(getDocumentList).subscribe((response) => {
      if (response !== undefined && response.Documents.length > 0) {
        response.Documents.forEach(res => {
          this.notesList.forEach(ele => {
            if (ele.id === res.agreementNoteId) {
              this.uploadFileList.push(res);
              ele.uploadFileList = this.uploadFileList;
            }
          });
        });
      }
    });
  }

  public addDocument() {
    if (this.validateDocumentSave()) {
      this.dialogRef.close(this.documentFormGroup.value);
      this.saveDocuments();
    }
  }

  // To validate form
  validateDocumentSave() {
    if (this.documentFormGroup.controls.documentType.value) {
      this.isDocumentTypeSelected = false;
    } else {
      this.isDocumentTypeSelected = true;
    }
    if (!(this.uploadFile === '') || this.validateFile === false) {
      this.isDocumentSelected = false;
    } else {
      this.isDocumentSelected = true;
    }
    this.isValidForm = (this.isDocumentTypeSelected === false && this.isDocumentSelected === false) ? true : false;
    return this.isValidForm;

  }

  // To save documents
  public saveDocuments() {
    if (this.newUploadFileList.length > 0) {
      this.newUploadFileList.forEach((element: any) => {
        element.agreementId = this.agreementId;
      });
      this.commonService.saveDocument(JSON.stringify(this.newUploadFileList)).subscribe((response: any) => {
        if (response) {
          this.isEnableDocumentDialug = false;
          this.notificationService.show({
            content: 'Document saved successfully.',
            position: { horizontal: 'center', vertical: 'bottom' },
            animation: { type: 'fade', duration: 500 },
            type: { style: 'success', icon: true },
            hideAfter: 1000,
          });
          this.getDocumentDetails(this.agreementNoteId);
        }
      });
    }
  }

  resetValidation() {
    this.isDocumentTypeSelected = false;
    this.isDocumentSelected = false;
    this.isExistingDocumentName = false;
    this.validateFile = false;
  }

  public openUploadDocumentDialog(template: TemplateRef<any>, dataItem: any) {
    this.documentFormGroup.reset();
    this.newUploadFileList = [];
    this.resetValidation();
    this.isEditDocumentDialug = false;
    this.agreementNoteId = dataItem.id;
    this.agreementYear = dataItem.agreementYear ? dataItem.agreementYear : null;
    this.disabledSelectFileButton = false;
    if (this.agreementNoteId) {
      this.getDocumentDetails(this.agreementNoteId);
    }
    this.disabledUploadButton = false;
    this.isEnableDocumentDialug = true;
    this.dialogRef = this.dialogService.open({
      title: 'Documents',
      content: template,
      width: 400,
    });
    this.dialogRef.result.subscribe((rs: any) => {
      if (rs instanceof DialogCloseResult) {
        this.isEnableDocumentDialug = false;
        return;
      }
      const newDocument: IDocument = {};
      newDocument.id = this.defaultGuid;
      newDocument.agreementNoteId = dataItem.id ? dataItem.id : null;
      newDocument.documentTypeId = rs.documentType.DocumentTypeId;
      newDocument.documentTypeName = rs.documentType.Description;
      newDocument.description = rs.documentDescription;
      newDocument.agreementYear = this.agreementYear;
      newDocument.documentName = this.fileName;
      newDocument.displayFileName = this.fileName;
      newDocument.spDocumentName = this.SpDocumentName;
      newDocument.documentURI = this.documentUri;
      newDocument.fileExtensionTypeId = 1;
      newDocument.isActive = true;
      newDocument.deliverableId = null;
      newDocument.agreementPriorApprovalId = null;
      newDocument.financialInformationId = null;
      this.newUploadFileList.push(newDocument);
      this.fileName = '';
      this.documentUri = '';
    }
    );
  }

  public editDocument(template: TemplateRef<any>, dataItem: any, rowIndex: any) {
    this.documentFormGroup.reset();
    this.newUploadFileList = [];
    this.resetValidation();
    this.agreementNoteId = dataItem.agreementNoteId;
    this.agreementYear = dataItem.agreementYear ? dataItem.agreementYear : null;
    this.disabledUploadButton = true;
    this.disabledSelectFileButton = true;
    this.fileExtension = '';
    this.isEditDocumentDialug = true;
    if (dataItem.documentName) {
      this.orgFileName = dataItem.documentName.split('.');
      this.fileExtension = dataItem.documentName.substr(dataItem.documentName.lastIndexOf('.') + 1);
    }
    this.documentFormGroup.patchValue({
      displayFileName: this.orgFileName[0],
      documentType: {
        DocumentTypeId: dataItem.documentTypeId,
        Description: dataItem.documentTypeName
      },
      documentDescription: dataItem.description,
    });
    this.isEnableDocumentDialug = true;
    this.dialogRef = this.dialogService.open({
      title: 'edit documents',
      content: template,
      width: 400,
    });
    this.dialogRef.result.subscribe((rs: any) => {
      if (rs instanceof DialogCloseResult) {
        this.isEnableDocumentDialug = false;
        return;
      }
      const currentRecord = this.uploadFileList[rowIndex];
      if (this.fileName.trim() && this.fileName !== currentRecord.documentName) {
        this.commonService.deleteDocumnetFile(JSON.stringify(dataItem.documentURI)).subscribe();
      }
      currentRecord.id = dataItem.id;
      currentRecord.agreementId = this.agreementId ? this.agreementId : this.defaultGuid;
      currentRecord.agreementNoteId = this.agreementNoteId ? this.agreementNoteId : null;
      const name = rs.displayFileName + '.' + this.fileExtension;
      currentRecord.displayFileName = name;
      currentRecord.spDocumentName = dataItem.spDocumentName;
      currentRecord.documentTypeId = rs.documentType.DocumentTypeId;
      currentRecord.documentTypeName = rs.documentType.Description;
      currentRecord.description = rs.documentDescription;
      currentRecord.documentName = name ? name : rs.displayFileName;
      currentRecord.documentURI = this.documentUri ? this.documentUri : currentRecord.documentURI;
      currentRecord.agreementYear = this.agreementYear;
      currentRecord.fileExtensionTypeId = 1;
      currentRecord.isActive = true;
      currentRecord.agreementPriorApprovalId = null;
      currentRecord.deliverableId = null;
      currentRecord.financialInformationId = null;
      this.newUploadFileList.push(currentRecord);
    });
    this.fileName = '';
    this.documentUri = '';
  }

  public deleteDocument(dataItem: any, rowIndex: number) {
    this.selectedDataItem = dataItem;
    this.selectedRowIndex = rowIndex;
    if (this.selectedDataItem.documentURI !== null) {
      this.dialogRef = this.dialogService.open({
        title: 'Please Confirm',
        content: 'Are you sure, do you want to delete it?',
        actions: [
          { text: 'Yes', primary: true },
          { text: 'No' }],
        width: 400,
      });
      this.dialogRef.result.subscribe((rs: any) => {
        if (rs.text && rs.text === 'Yes') {
          if (this.selectedDataItem.id) {
            Common.loader('show');
            this.deleteDocuments.push(this.selectedDataItem.id);
            this.commonService.deleteDocumnetFile(JSON.stringify(this.selectedDataItem.documentURI)).subscribe((res: any) => {
              if (res) {
                this.commonService.deleteDocument(JSON.stringify(this.deleteDocuments)).subscribe((response: any) => {
                  if (response) {
                    this.notificationService.show({
                      content: 'This has been deleted.',
                      position: { horizontal: 'center', vertical: 'bottom' },
                      animation: { type: 'fade', duration: 500 },
                      type: { style: 'success', icon: true },
                      hideAfter: 1000,
                    });
                    Common.loader('hide');
                  }
                });
              }
            });
            this.uploadFileList.splice(this.selectedRowIndex, 1);
          } else {
            this.uploadFileList.splice(this.selectedRowIndex, 1);
          }
        }
      });
    } else {
      this.dialogRef = this.dialogService.open({
        title: 'Information',
        content: 'Document does not exist',
        actions: [
          { text: 'Ok', primary: true }
        ],
        width: 400,
      });
    }
  }

  public downloadDocument(dataItem: any) {
    if (dataItem.documentURI) {
      Common.loader('show');
      this.commonService.downloadDocument(dataItem.documentURI)
        .subscribe((data) => {
          const anchor = document.createElement('a');
          anchor.download = dataItem.documentName;
          const ext = dataItem.documentURI.substr(dataItem.documentURI.lastIndexOf('.') + 1);
          const blob = this.base64ToBlob(data);
          anchor.href = URL.createObjectURL(blob);
          anchor.dataset.downloadurl = [this.mimeMapping.get(ext), anchor.download, anchor.href].join(':');
          anchor.click();
          Common.loader('hide');
        });
    } else {
      this.dialogRef = this.dialogService.open({
        title: 'Information',
        content: 'Document does not exist',
        actions: [
          { text: 'Ok', primary: true }
        ],
        width: 400,
      });
    }
  }

  public base64ToBlob(b64Data, contentType = '', sliceSize = 512) {
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: 'application/octet-stream' });
  }

  resetPreview() {
    this.url = '';
    this.data = '';
    this.headData = '';
    this.isEnablePDF = false;
    this.isEnableXLXS = false;
    this.isEnableJPG = false;
    this.isEnableTXT = false;
    this.isEnablemsg = false;
    this.isEnableDOCX = false;
  }

  enablePreviewDialog(template: TemplateRef<any>, dataItem: any) {
    if (dataItem.documentURI) {
      this.resetPreview();
      this.enablePreviewDataItem = dataItem;
      const extension = dataItem.documentURI.substr(dataItem.documentURI.lastIndexOf('.') + 1);
      this.dialogPreviewRef = this.dialogService.open({
        title: 'Preview',
        content: template,
        width: 800,
        height: 600,
      });
      Common.loader('show');
      if (extension === 'docx' || extension === 'msg' || extension === 'doc' || extension === 'zip' || extension === 'html') {
        this.isEnableDOCX = true;
        this.documentURI = dataItem.documentURI;
        Common.loader('hide');
      } else {
        this.commonService.downloadDocument(dataItem.documentURI)
          .subscribe((data) => {
            this.documentURI = dataItem.documentURI;
            const blob = this.previewBlob(data, extension);
            if (extension === 'txt') {
              this.isEnableTXT = true;
              const fileReader = new FileReader();
              fileReader.onload = (e) => {
                this.url = e.target.result;
              };
              fileReader.readAsText(blob);
            } else if (extension === 'xlsx' || extension === 'xls' || extension === 'csv') {
              this.isEnableXLXS = true;
              const target = blob;
              const reader: FileReader = new FileReader();
              reader.onload = (e: any) => {
                /* read workbook */
                const bstr: string = e.target.result;
                const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
                /* grab first sheet */
                const wsname: string = wb.SheetNames[0];
                const ws: XLSX.WorkSheet = wb.Sheets[wsname];
                /* save data */
                this.data = ((XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, range: 0 })) as AOA);
                this.headData = this.data[0];
                this.data = this.data.slice(1); // remove first header record
                const ws2: XLSX.WorkSheet = wb.Sheets[wb.SheetNames[1]];
                this.readDataSheet(ws2, 1);
              };
              reader.readAsBinaryString(target);
            } else if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
              this.isEnableJPG = true;
              const reader = new FileReader();
              reader.onload = (ev) => {
                this.url = ev.target.result;
              };
              reader.readAsDataURL(blob);
            } else if (extension === 'pdf') {
              this.isEnablePDF = true;
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onload = (ev) => {
                this.url = ev.target.result;
              };
            }
            Common.loader('hide');
          });
      }
    }
  }

  private readDataSheet(ws: XLSX.WorkSheet, startRow: number) {
    /* save data */
    let datas = (XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, range: startRow })) as AOA;
    const headDatas = datas[0];
    datas = datas.slice(1); // remove first header record
    for (let i = 0; i < this.data.length; i++) {
      this.data[i][this.headData.length] = datas.filter(x => x[12] === this.data[i][0]);
    }
  }

  public previewBlob(b64Data, ext: any, contentType = '', sliceSize = 512) {
    let tempdata: any;
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    if (ext === 'png') {
      tempdata = new Blob(byteArrays, { type: 'image/png' });
    } else if (ext === 'jpg') {
      tempdata = new Blob(byteArrays, { type: 'image/jpg' });
    } else if (ext === 'jpeg') {
      tempdata = new Blob(byteArrays, { type: 'image/jpeg' });
    } else if (ext === 'pdf') {
      tempdata = new Blob(byteArrays, { type: 'application/pdf' });
    } else if (ext === 'ppt') {
      tempdata = new Blob(byteArrays, { type: 'application/vnd.ms-powerpoint' });
    } else if (ext === 'pptx') {
      tempdata = new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
    } else if (ext === 'rtf') {
      tempdata = new Blob(byteArrays, { type: 'application/rtf' });
    } else {
      tempdata = new Blob(byteArrays, { type: 'application/octet-stream' });
    }
    return tempdata;
  }

  public selectEventHandler(event: SelectEvent) {
    if (event.files && event.files.length > 0) {
      if (!event.files[0].validationErrors) {
        this.uploadFile = event.files[0].rawFile;
        this.isDocumentSelected = false;
        this.onFileSelected(event);
      } else {
        this.uploadFile = this.defaultGuid;
        this.isDocumentSelected = true;
        this.isExistingDocumentName = false;
      }
    }
  }

  onFileSelected(event) {
    const file: File = event.files[0].rawFile;
    const attachment: any = {};
    if (file) {
      Common.loader('show');
      this.disabledUploadButton = false;
      const validateDocumentName = this.uploadFileList.find((ele) => ele.spDocumentName === file.name);
      if (validateDocumentName) {
        this.isExistingDocumentName = true;
        this.selectedDataItem = validateDocumentName;
        Common.loader('hide');
      } else {
        this.fileName = file.name;
        attachment.agreementId = this.agreementId ? this.agreementId : this.defaultGuid;
        attachment.agreementName = this.awardTitle;
        attachment.awardNumber = this.awardNumber;
        attachment.nickName = this.awardNickName;
        attachment.moduleName = this.moduleName;
        attachment.agreementYear = this.agreementYear;
        attachment.documentType = this.documentFormGroup.controls.documentType.value.Description;
        if (file) {
          this.orgFileName = file.name.split('.');
          this.documentFormGroup.patchValue({ displayFileName: this.orgFileName[0]});
          this.fileExtension = this.orgFileName[1];
        }
        this.commonService.uploadAttachment(attachment, file).subscribe((res: any) => {
          if (res) {
            Common.loader('hide');
            this.documentUri = res;
            const fileName = this.documentUri.substr(this.documentUri.lastIndexOf('/') + 1, this.documentUri.length);
            this.SpDocumentName = fileName.split('.')[0];
            this.disabledUploadButton = true;
            this.isExistingDocumentName = false;
          }
        });
      }
    }
  }

  async getFileBuffer(file: File): Promise<ArrayBuffer> {
    const buffer = await new Response(file).arrayBuffer();
    return buffer;
  }

  public clearEventHandler(event: ClearEvent) {
    this.uploadFile = this.defaultGuid;
  }

  public removeEventHandler(event: RemoveEvent) {
    this.uploadFile = this.defaultGuid;
  }

  public overrideYes(data: any) {
    if (data === 'Yes') {
      Common.loader('show');
      if (this.selectedDataItem.id) {
        if (this.selectedDataItem.documentURI) {
          // to delete the existing file.
          this.commonService.deleteDocumnetFile(JSON.stringify(this.selectedDataItem.documentURI)).subscribe();
        }
        // to upload document
        const attachment: any = {};
        this.fileName = this.uploadFile.name;
        attachment.agreementId = this.agreementId ? this.agreementId : this.defaultGuid;
        attachment.agreementName = this.awardTitle;
        attachment.awardNumber = this.awardNumber;
        attachment.nickName = this.awardNickName;
        this.commonService.uploadAttachment(attachment, this.uploadFile).subscribe((res: any) => {
          if (res) {
            this.documentUri = res;
            const fileList: IDocument[] = [];
            this.selectedDataItem.documentURI = this.documentUri;
            this.selectedDataItem.displayFileName = this.documentFormGroup.controls.displayFileName.value;
            this.selectedDataItem.documentTypeId = this.documentFormGroup.controls.documentType.value.DocumentTypeId;
            this.selectedDataItem.documentTypeName = this.documentFormGroup.controls.documentType.value.Description;
            this.selectedDataItem.description = this.documentFormGroup.controls.documentDescription.value;
            fileList.push(this.selectedDataItem);
            // to save the agreement document.
            this.commonService.saveDocument(JSON.stringify(fileList)).subscribe((response: any) => {
              if (response) {
                this.getDocumentDetails(this.agreementNoteId);
                this.dialogRef.close(this.documentFormGroup.value);
                Common.loader('hide');
              }
            });
          }
        });
      }
    }
    else {
      this.dialogRef.close();
    }
  }

  autoSave() {
    this.intervaltime = setInterval(() => {
      if (this.isEnableDocumentDialug === false) {
        if (this.notesEntryForm.touched) {
          const element: HTMLElement = document.getElementById('submitBtn') as HTMLElement;
          element.click();
          $('.notesSave').click();
        }
      }
    }, +environment.autoSave);
  }

  ngOnDestroy() {
    if (this.intervaltime) {
      clearInterval(this.intervaltime);
    }
  }
}
